import CardHeading from '@commons/headings/card'
import ScrollView from '@commons/scroll'
import InstantAppointmentRequestCard from '@commons/cards/instantAppointmentRequest'
import InstantAppointmentRequestCardLoader from '@commons/cards/instantAppointmentRequest/loader'
import Empty from '@commons/empty'
import { styleCardItem } from './style'
import { useEffect, Fragment } from 'react'
import { useSelector } from 'react-redux'
import { Appointment } from '@apis'
const InstantRequests = () => {
  const { items: appointments, loading } = useSelector(
    (state: any) => state.homeInstanConsultAppointments,
  )
  const fetchData = async () => {
    await Appointment.list({
      params: {
        isInstant: true,
        type: 'Consult',
        status: 'Pending',
      },
      state: 'homeInstanConsultAppointments',
      action: 'set',
    }).catch(() => {})
  }
  useEffect(() => {
    if (!appointments?.length) {
      fetchData()
    }
  }, [])

  return (
    <>
      <CardHeading
        tc="primary"
        title="Instant Consultation Requests"
        hasView
        path="/doctor/appointments/instants"
      />
      <ScrollView>
        {!!loading ? (
          <>
            {Array(6)
              .fill(0)
              ?.map((_: any, index: any) => {
                return (
                  <Fragment key={index}>
                    <InstantAppointmentRequestCardLoader
                      styleCard={styleCardItem}
                    />
                  </Fragment>
                )
              })}
          </>
        ) : (
          <>
            {!!appointments?.length ? (
              <>
                {appointments?.map((appointment: any) => {
                  return (
                    <Fragment key={appointment?.id}>
                      <InstantAppointmentRequestCard
                        styleCard={styleCardItem}
                        appointment={appointment}
                      />
                    </Fragment>
                  )
                })}
              </>
            ) : (
              <Empty />
            )}
          </>
        )}
      </ScrollView>
    </>
  )
}

export default InstantRequests
